var map = {
	"./atlas.png": 425,
	"./bg_day.png": 426,
	"./bg_night.png": 427,
	"./bird0_0.png": 428,
	"./bird0_1.png": 429,
	"./bird0_2.png": 430,
	"./bird1_0.png": 431,
	"./bird1_1.png": 432,
	"./bird1_2.png": 433,
	"./bird2_0.png": 434,
	"./bird2_1.png": 435,
	"./bird2_2.png": 436,
	"./black.png": 437,
	"./blink_00.png": 438,
	"./blink_01.png": 439,
	"./blink_02.png": 440,
	"./brand_copyright.png": 441,
	"./button_menu.png": 442,
	"./button_ok.png": 443,
	"./button_pause.png": 444,
	"./button_play.png": 445,
	"./button_rate.png": 446,
	"./button_restart.png": 447,
	"./button_resume.png": 448,
	"./button_score.png": 449,
	"./button_share.png": 450,
	"./font_048.png": 451,
	"./font_049.png": 452,
	"./font_050.png": 453,
	"./font_051.png": 454,
	"./font_052.png": 455,
	"./font_053.png": 456,
	"./font_054.png": 457,
	"./font_055.png": 458,
	"./font_056.png": 459,
	"./font_057.png": 460,
	"./land.png": 461,
	"./medals_0.png": 462,
	"./medals_1.png": 463,
	"./medals_2.png": 464,
	"./medals_3.png": 465,
	"./new.png": 466,
	"./number_context_00.png": 467,
	"./number_context_01.png": 468,
	"./number_context_02.png": 469,
	"./number_context_03.png": 470,
	"./number_context_04.png": 471,
	"./number_context_05.png": 472,
	"./number_context_06.png": 473,
	"./number_context_07.png": 474,
	"./number_context_08.png": 475,
	"./number_context_09.png": 476,
	"./number_context_10.png": 477,
	"./number_score_00.png": 478,
	"./number_score_01.png": 479,
	"./number_score_02.png": 480,
	"./number_score_03.png": 481,
	"./number_score_04.png": 482,
	"./number_score_05.png": 483,
	"./number_score_06.png": 484,
	"./number_score_07.png": 485,
	"./number_score_08.png": 486,
	"./number_score_09.png": 487,
	"./pipe2_down.png": 488,
	"./pipe2_up.png": 489,
	"./pipe_down.png": 490,
	"./pipe_up.png": 491,
	"./score_panel.png": 492,
	"./score_panel_2.png": 493,
	"./text_game_over.png": 494,
	"./text_ready.png": 495,
	"./title.png": 496,
	"./tutorial.png": 497,
	"./white.png": 498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;